import { apiGet, apiPost, apiPut, apiPatch, apiDelete } from '@/app/api/core/http';
import { createImage, updateImage } from '@/app/api/core/images';
import { CAT_VARIATIONS, CAT_CONSUMABLE_VARIATIONS } from 'App/utils/Collections';
import { PRODUCTS_PATHS } from './paths';

export const variationsApiAdapter = {
  [CAT_VARIATIONS]: {
    getList: (params) => apiGet(PRODUCTS_PATHS.variations + PRODUCTS_PATHS.suffix, { params }),
    getItem: (id, params) => apiGet(`${PRODUCTS_PATHS.variations}/${id}`, { params }),
    create: (data) => apiPost(PRODUCTS_PATHS.variations, { data }),
    update: (id, data) => apiPut(`${PRODUCTS_PATHS.variations}/${id}`, { data }),
    updateItem: (id, data) => apiPatch(`${PRODUCTS_PATHS.variations}/${id}`, { data }),
    remove: (id) => apiDelete(`${PRODUCTS_PATHS.variations}/${id}`),
  },
  getProductVariations: (params) => apiGet(PRODUCTS_PATHS.variations + PRODUCTS_PATHS.suffix, { params }),
  variationImages: {
    getList: (params) => apiGet(PRODUCTS_PATHS.variationImages, { params }),
    getItem: (id) => apiGet(`${PRODUCTS_PATHS.variationImages}/${id}`),
    create: (img, variation_id, is_default = false, session_interval = 0) =>
      createImage(CAT_VARIATIONS, img, {
        variation_id,
        is_default,
        session_interval,
      }),
    update: (id, data) => updateImage(CAT_VARIATIONS, id, data),
    remove: (id) => apiDelete(`${PRODUCTS_PATHS.variationImages}/${id}`),
  },
  [CAT_CONSUMABLE_VARIATIONS]: {
    getList: (params) => apiGet(PRODUCTS_PATHS.consumableVariations + PRODUCTS_PATHS.suffix, { params }),
    getItem: (id, params) => apiGet(`${PRODUCTS_PATHS.consumableVariations}/${id}`, { params }),
    create: (data) => apiPost(PRODUCTS_PATHS.consumableVariations, { data }),
    update: (id, data) => apiPatch(`${PRODUCTS_PATHS.consumableVariations}/${id}`, { data }),
  },
};
